import { PdfData } from "./types";

const EpidemicData = {
  title: "Epidemic",
  description: {
    i18nKey: "Epidemic_form_message",
    label:
      "Please note here illness / disease contagious which presented itself in at least 4 members of the nursery (children / staff) within 10 working days, and had presented a high likelihood of infecting other staff and children at the nursery",
  },
  fields: [
    {
      name: "eventDate",
      label: "Event Date",
    },
    {
      name: "illness",
      label: "Illness/Infections",
    },
    {
      name: "numberOfChildren",
      label: "Number of Children",
    },
    {
      name: "numberOfTeacher",
      label: "Number of Teacher/Adult infected",
    },
    {
      name: "actionTaken",
      label: "Actions Taken",
    },
  ],
};

export default EpidemicData;
